var ActionTypes = {
    // Dashboard actions
    DASHBOARD_UPDATE_MAP_FILTER: "DASHBOARD_UPDATE_MAP_FILTER",
    DASHBOARD_SET_MAP_RESULT: "DASHBOARD_SET_MAP_RESULT",
    DASHBOARD_RESET_MAP_RESULT: "DASHBOARD_RESET_MAP_RESULT",
    DASHBOARD_SET_MAP_COLORS: "DASHBOARD_SET_MAP_COLORS",
    DASHBOARD_SET_MAP_HOVERED_AREA: "DASHBOARD_SET_MAP_HOVERED_AREA",
    DASHBOARD_SET_MAP_HOVERED_INJECTOR: "DASHBOARD_SET_MAP_HOVERED_INJECTOR",
    DASHBOARD_SET_MAP_TOKEN: "DASHBOARD_SET_MAP_TOKEN",
    DASHBOARD_SET_MAP: "DASHBOARD_SET_MAP",
    DASHBOARD_SET_MAP_ICONS: "DASHBOARD_SET_MAP_ICONS",
    DASHBOARD_SET_MAP_SHOW_AREAS: "DASHBOARD_SET_MAP_SHOW_AREAS",
    DASHBOARD_MAP_RESET_VIEW: "DASHBOARD_MAP_RESET_VIEW",
    DASHBOARD_SET_MAP_SELECTED_TAB: "DASHBOARD_SET_MAP_SELECTED_TAB",
    DASHBOARD_MAP_SET_TASK: "DASHBOARD_MAP_SET_TASK",
    DASHBOARD_SET_MAP_SELECTED_FIELD: "DASHBOARD_SET_MAP_SELECTED_FIELD",
    DASHBOARD_MAP_CHANGE_UNIT_TYPE_MODE: "DASHBOARD_MAP_CHANGE_UNIT_TYPE_MODE",
    DASHBOARD_MAP_TOGGLE_FILTERS_MODAL: "DASHBOARD_MAP_TOGGLE_FILTERS_MODAL",
    DASHBOARD_MAP_TOGGLE_AREAS_EDIT_MODAL: "DASHBOARD_MAP_TOGGLE_AREAS_EDIT_MODAL",

    // static reports tab
    SR_SET_MASTER_LEVEL: "SR/SET MASTER LEVEL",
    SR_TOGGLE_MASTER_SPINNER: "SR/TOGGLE MASTER SPINNER",
    SR_SET_LOOKUPS: "SR/SET LOOKUPS",
    SR_RESET: "SR/SR_RESET",
    SR_SET_SETTINGS: "SR/SR_SET_SETTINGS",
    SR_SET_CASES: "SR/SR_SET_CASES",
    SR_SET_CASES_SELECTED: "SR/SR_SET_CASES_SELECTED",
    SR_SET_CASES_FILTER: "SR/SET_CASES_FILTER",
    SR_SET_TABLES: "SR/SR_SET_TABLES",
    SR_ADD_NEW_TAB: 'SR/SR_ADD_NEW_TAB',
    SR_CHANGE_TAB_CONTENTS: 'SR/SR_CHANGE_TAB_CONTENTS',
    SR_SET_ACTIVE_TAB: 'SR/SR_SET_ACTIVE_TAB',
    SR_SET_RESULT_DATA: 'SR/SR_SET_RESULT_DATA',
    SR_CLOSE_TAB: 'SR/SR_CLOSE_TAB',
    SR_SET_GRID_COLUMNS: 'SR/SR_SET_GRID_COLUMNS',
    SR_SET_GRID_ROWS: 'SR/SR_SET_GRID_ROWS',
    SR_RESET_EDITOR_TAB: 'SR/SR_RESET_EDITOR_TAB',
    SR_SET_STATIC_REPORTS: "SR/SR_SET_STATIC_REPORTS",
    SR_SET_TEMPLATE: "SR/SR_SET_TEMPLATE",
    SR_SET_TEMPLATE_SELECTED: "SR/SR_SET_TEMPLATE_SELECTED",
    SR_SET_REPORT_SELECTED: "SR/SR_SET_REPORT_SELECTED",
    SR_SET_ATHENA_HISTORIES: "SR/SR_SET_ATHENA_HISTORIES",
    SR_SET_ATHENA_FILTER: "SR/SR_SET_ATHENA_FILTER",
    SR_TOGGLE_RESULT_SPINNER: "SR/SR_TOGGLE_RESULT_SPINNER",
    SR_OPEN_EDIT_MODAL: "SR/SR_OPEN_EDIT_MODAL",
    SR_CLOSE_EDIT_MODAL: "SR/SR_CLOSE_EDIT_MODAL",
    SR_EDIT_MODAL_CHANGE_FIELDS: "SR/SR_EDIT_MODAL_CHANGE_FIELDS",
    SR_OPEN_TEMPLATE_MODAL: "SR/SR_OPEN_TEMPLATE_MODAL",
    SR_CLOSE_TEMPLATE_MODAL: "SR/SR_CLOSE_TEMPLATE_MODAL",
    SR_TOGGLE_TEMPLATE_MODAL_SPINNER: "SR/SR_TOGGLE_TEMPLATE_MODAL_SPINNER",
    SR_SET_TABS: "SR/SR_SET_TABS",
    SR_SET_END_QUERYS: "SR/SR_SET_END_QUERYS",
    SR_RESET_RESULT_DATA: "SR/SR_RESET_RESULT_DATA",
    SR_SET_TASK_ID: "SR/SR_SET_TASK_ID",

    // OTI actions
    OTI_SWITCH_DETAIL: "OTI/SWITCH DETAIL",
    OTI_MASTER_SELECTED: "OTI/MASTER SELECTED",
    OTI_MASTER_CHECKED: "OTI/MASTER CHECKED",
    OTI_DETAIL_SELECTED: "OTI/DETAIL SELECTED",
    OTI_DETAIL_CHECKED: "OTI/DETAIL CHECKED",
    OTI_TOGGLE_MASTER_SPINNER: "OTI/TOGGLE MASTER SPINNER",
    OTI_TOGGLE_DETAIL_SPINNER: "OTI/TOGGLE DETAIL SPINNER",
    OTI_SET_MASTER_SOURCE: "OTI/SET MASTER SOURCE",
    OTI_SET_DETAIL_SOURCE: "OTI/SET DETAIL SOURCE",
    OTI_SET_MASTER_FILTER: "OTI/SET MASTER FILTER",
    OTI_SET_DETAIL_FILTER: "OTI/SET DETAIL FILTER",
    OTI_RESET_MASTER_FILTER: "OTI/RESET MASTER FILTER",
    OTI_RESET_DETAIL_FILTER: "OTI/RESET DETAIL FILTER",
    OTI_TOGGLE_CONFIGURATION_MODAL: "OTI/TOGGLE CONFIGURATION MODAL",
    OTI_TOGGLE_CONFIGURATION_MODAL_LOCKED: "OTI/TOGGLE CONFIGURATION MODAL LOCKED",
    OTI_SET_CONFIGURATION_MODAL_LOOKUP: "OTI/SET CONFIGURATION MODAL LOOKUP",
    OTI_SET_CONFIGURATION_MODAL_SOURCE: "OTI/SET CONFIGURATION MODAL SOURCE",
    OTI_SET_CONFIGURATION_MODAL_ERRORS: "OTI/SET CONFIGURATION MODAL ERRORS",
    OTI_SET_CONFIGURATION_MODAL_HEADER: "OTI/SET CONFIGURATION MODAL HEADER",
    OTI_SET_DATA_TYPE_FILTERS: "OTI/SET DATA TYPE FILTERS",
    OTI_TOGGLE_AREAS_EDIT_MODAL: "OTI/TOGGLE AREAS EDIT MODAL",
};

export default ActionTypes;
